import React, { useState } from 'react';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, Modifier, CompositeDecorator, SelectionState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import '../../styles/CoverLetter.css'
import { Button, Typography } from '@mui/material';
import SparklesIcon from '../../assets/svgs/SparklesIcon';
import ReactGA from 'react-ga4'

/*function ColorPic(props) {
    const stopPropagation = (event) => {
        event.stopPropagation();
    };
  
    const onChange = (color) => {
        props.onChange('color', color.hex);
    }
  
    const renderModal = () => {
        const { color } = props.currentState;
        return (
            <div
            onClick={stopPropagation}
            >
            <BlockPicker color={color} onChangeComplete={onChange} />
            </div>
        );
    };
  
    return (
        <div
            aria-haspopup="true"
            aria-expanded={expanded}
            aria-label="rdw-color-picker"
        >
            <div onClick={onExpandEvent}>
                <img src={icon} alt=""/>
            </div>
            {expanded ? renderModal() : undefined}
        </div>
      );
}*/

const customStyleMap = {
    LTR: {
        direction: 'ltr',
        display: 'inline-block',
        unicodeBidi: 'isolate',
    },
};

const LtrSpan = (props) => {
    return (
      <span style={{ direction: 'ltr', display: 'inline-block', textAlign: 'left' }}>
        {props.children}
      </span>
    );
  };
  
  // 👇 Finds entity ranges to decorate
  const findLTREntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
      (character) => {
        const key = character.getEntity();
        return key !== null && contentState.getEntity(key).getType() === 'LTR';
      },
      callback
    );
  };
  
  // 👇 Decorator for LTR entities
  const decorator = new CompositeDecorator([
    {
      strategy: findLTREntities,
      component: LtrSpan,
    },
]);

const CustomOption = ({ editorState, onChange }) => {
    const removeStyles = () => {
        const contentState = editorState.getCurrentContent();
        const blockMap = contentState.getBlockMap();
    
        const newBlockMap = blockMap.map(block => {
            const inlineStyles = block.getCharacterList().map(char => {
            const styles = char.getStyle();
            const newStyles = styles.filter(style => !style.startsWith('FONTSIZE') && !style.startsWith('FONTFAMILY') && !style.startsWith('fontsize') && !style.startsWith('fontfamily'));
            return char.set('style', newStyles.add('fontsize-16').add('fontfamily-Arial'));
            });
    
            return block.set('characterList', inlineStyles);
        });
  
        const newContentState = contentState.set('blockMap', newBlockMap);
        onChange(EditorState.push(editorState, newContentState, 'change-inline-style'));
    };

    const applyLTREntity = (editorState, setEditorState) => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'LTR',
            'MUTABLE',
            { dir: 'ltr' }
        );
      
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const selection = editorState.getSelection();
      
        const newContentState = Modifier.applyEntity(
            contentStateWithEntity,
            selection,
            entityKey
        );
      
        const newEditorState = EditorState.push(
            editorState,
            newContentState,
            'apply-entity'
        );
      
        setEditorState(newEditorState);
    };
  
    return (
        <>
            <div className='rdw-option-wrapper' onClick={removeStyles}>font auto-fix</div>
            <div className='rdw-option-wrapper' onClick={() => applyLTREntity(editorState, onChange)}>LTR</div>
        </>
    );
};

export function  JSTextEdidor(props) {
    const value = props.value;
    /*const contentBlock = htmlToDraft(html);
    let editorStateP
    if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        editorStateP = EditorState.createWithContent(contentState);
    }*/

    /*const placeholderCL = "שלום רב, \n\n"+
        "שמי ___, ___ [טייטל מטרה].\n\n"+
        "יש לי ניסיון של ___ כ___ [טייטל אחרון] ב____ [שם הארגון], וכן ניסיון של ___ כ___.\n\n"+
        "במסגרת תפקידי הובלתי ולקחתי חלק בפרויקטים שכללו . בנוסף, יש לי ניסיון ב וב___, תוך עבודה עם ___.\n\n"+
        "אשמח להביא את הניסיון והיכולות שלי לידי ביטוי בתפקיד ____.\n\n"+
        "תודה על זמנכם והתייחסותכם,\n"+
        "קורות החיים שלי מצורפים.\n\n"+
        "בברכה,\n"+
        "שם\n"+
        "טלפון\n"+
        "מייל"*/

    const blocksFromHtml = htmlToDraft(value);
    let contentState = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap
    );
    
    // Find all <span dir="ltr">...</span> in raw HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');
    const spanNodes = Array.from(doc.querySelectorAll('span[dir="ltr"]'));
    const ltrTexts = spanNodes.map((node) => node.textContent).filter(Boolean);
    
    // Apply LTR entity to each matching string
    const blockMap = contentState.getBlockMap();
    blockMap.forEach((block) => {
        const blockText = block.getText();
        ltrTexts.forEach((ltrText) => {
            let start = blockText.indexOf(ltrText);
            while (start !== -1) {
                const end = start + ltrText.length;

                // Create entity
                contentState = contentState.createEntity('LTR', 'MUTABLE', { dir: 'ltr' });
                const entityKey = contentState.getLastCreatedEntityKey();

                const selection = SelectionState.createEmpty(block.getKey()).merge({
                    anchorOffset: start,
                    focusOffset: end,
                });

                contentState = Modifier.applyEntity(contentState, selection, entityKey);

                // In case the same LTR text appears multiple times
                start = blockText.indexOf(ltrText, end);
            }
        });
    });

    const newEditorState = EditorState.createWithContent(contentState, decorator);

    const [editorState, setEditorState] = useState(newEditorState);

    /*const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty(decorator)
    );*/

    /*useEffect(() => {
        // Parse HTML
        
    }, [value]);*/

    const onEditorStateChange = (editorState) => {
        setEditorState(editorState)

        const rawContent = convertToRaw(editorState.getCurrentContent());

        let htmlContent = draftToHtml(
            rawContent,
            null,
            true, // triggerInlineStyles
            (entity, text) => {
                if (entity.type === 'LTR') {
                return `<span dir="ltr">${text}</span>`;
                }
                return text;
            }
        );

        //let htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()), {}, true)

        htmlContent = htmlContent.replace(/<ul>/mgi, '<ul dir="auto">');

        props.onChange(htmlContent)
    };

    /*const handleReturn = (e, editorState) => {
        console.log(editorState)
        return false
    }//DraftHandleValue*/

    /*function removeFontStyles(string) {
        // Regular expressions to match font-size and font-family declarations
        const fontSizeRegex = /font-size:[^;]+;/g;
        const fontFamilyRegex = /font-family:[^;]+;/g;
      
        // Remove all occurrences of font-size and font-family
        let cleanedText = string.replace(fontSizeRegex, '').replace(fontFamilyRegex, '');
      
        return cleanedText;
    }*/

    const toolbar = props.limitToolbar ? {
        options: ['inline', 'textAlign', 'colorPicker',/* 'fontSize', 'fontFamily',*/ 'list', 'link', 'history'],
        inline: {
            options: ['bold', 'italic', 'underline', 'strikethrough'],
        },
        colorPicker: {
            //component: ColorPicker,
            colors: ['#1c4587', '#3c78d8', 'black', 'white'],
        },
        /*fontSize: {
            options: [16],
        },
        fontFamily: {
            options: ['Arial'],
        },*/
    }:{
        options: ['colorPicker', 'inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'emoji', 'remove', 'history'],
        colorPicker: {
          colors: ['#cea1d8','rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
            'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
            'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
            'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
            'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
            'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
        },
    }

    const handleUseRecommendedTemplate = () => {
        const suggestedCL = `<p dir="auto"><span style="font-size: 16px;font-family: Arial;">שלום רב,</span><br><br><span style="font-size: 16px;font-family: Arial;">שמי ___, ___ [טייטל מטרה].</span><br><br><span style="font-size: 16px;font-family: Arial;">יש לי ניסיון של ___ כ___ [טייטל אחרון] ב____ [שם הארגון], וכן ניסיון של ___ כ___.</span><br><br><span style="font-size: 16px;font-family: Arial;">במסגרת תפקידי הובלתי ולקחתי חלק בפרויקטים שכללו . בנוסף, יש לי ניסיון ב וב___, תוך עבודה עם ___.</span><br><br><span style="font-size: 16px;font-family: Arial;">אשמח להביא את הניסיון והיכולות שלי לידי ביטוי בתפקיד ____.</span><br><br><span style="font-size: 16px;font-family: Arial;">תודה על זמנכם והתייחסותכם,</span><br><span style="font-size: 16px;font-family: Arial;">קורות החיים שלי מצורפים.</span><br><br><span style="font-size: 16px;font-family: Arial;">בברכה,</span><br><span style="font-size: 16px;font-family: Arial;">שם</span><br><span style="font-size: 16px;font-family: Arial;">טלפון</span><br><span style="font-size: 16px;font-family: Arial;">מייל</span></p>`.replace(/(&nbsp;)+<\/p>/g, "</p>");

        const blocksFromHtml = htmlToDraft(suggestedCL);
        const { contentBlocks, entityMap } = blocksFromHtml;

        const contentState = ContentState.createFromBlockArray(
            contentBlocks,
            entityMap
        );

        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
    }

    return (
        <div style={{marginBottom:8}}>
            <Editor
                toolbarClassName="fixed-toolbar"
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
                editorClassName={"editor-html" + (props.isCoverLetters ? " cover-letter" : "")}
                //handleReturn={handleReturn}
                placeholder={props.isCoverLetters ? `Compose using template\nor from scratch` : "Type here"}
                toolbar={toolbar}
                toolbarCustomButtons={[<CustomOption />]}
                customStyleMap={customStyleMap}
            />
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                <div>
                    <Typography variant='caption'><b>Shift+Enter</b> - New Line</Typography><br/>
                    <Typography variant='caption'><b>Enter</b> - New Paragraph</Typography>
                </div>
                {props.isCoverLetters&&<div>
                    {!props.isActiveJHUser&&<Button onClick={handleUseRecommendedTemplate} size='small' color='primary' variant='contained' style={{marginTop: 8, textTransform: 'none'}}>
                        Use Template
                    </Button>}
                    {!props.isActiveJHUser&&<Button onClick={()=>ReactGA.event({category: 'Journey', action: `generate_cover_letter_with_ai_from_editor`})} size='small' startIcon={<SparklesIcon />} style={{textTransform: 'none', marginLeft: 8, boxShadow: 'none', marginTop: 8}} variant='contained' color='primary' href="https://chatgpt.com/g/g-69c640b59c888191a286e991d47b288d-jobhunt-cover-letter-builder" target='_blank'>Generate with AI</Button>}
                </div>}
            </div>
        </div>
    )
}